import { Pipe, PipeTransform } from '@angular/core';

export interface TranslationEnumMapping<T> {
  value: T;
  translation: string;
}

@Pipe({
  name: 'i18nEnum',
  pure: true,
})
export class I18nEnumPipe implements PipeTransform {
  transform<T>(
    value: T,
    translationMapping: TranslationEnumMapping<T>[]
  ): string {
    const res = translationMapping.find((e) => e.value === value);
    return res ? res.translation : '';
  }
}
